import { createAsyncThunk } from "@reduxjs/toolkit";
import "react-toastify/dist/ReactToastify.css";

//Include Both Helper File with needed methods
import resumeViewLogApi from "api/resumeViewLogApi";
import { formatQueryParams } from "helpers/format";

export const getResumeViewLogs = createAsyncThunk(
  "ResumeViewLogs",
  async (params: any = {}) => {
    try {
      const response = await resumeViewLogApi.viewResumeLogs(formatQueryParams(params));
      return response;
    } catch (error) {
      return error;
    }
  }
);

